import { useCallback } from "react";
import { useCurrentLocale } from "../useCurrentLocale";
import type { FormatDateTimeFn } from "./formatDateTime";
import { formatDateTime } from "./formatDateTime";
import type { FormatNumberFn } from "./formatNumber";
import { formatNumber } from "./formatNumber";
import type { DateTimeFormats, NumberFormats } from "./types";

export function useFormatter() {
    const { locale } = useCurrentLocale();

    const formatDateTimeFn = useCallback<FormatDateTimeFn>(
        (value: Date | number, format: DateTimeFormats) =>
            formatDateTime(value, format, locale),
        [locale],
    );

    const formatNumberFn = useCallback<FormatNumberFn>(
        (value: number, format: NumberFormats) =>
            formatNumber(value, format, locale),
        [locale],
    );

    return {
        formatDateTime: formatDateTimeFn,
        formatNumber: formatNumberFn,
    };
}
